import { render, staticRenderFns } from "./EditClient.vue?vue&type=template&id=1b1ae59a"
import script from "./EditClient.vue?vue&type=script&lang=js"
export * from "./EditClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports